export interface KitProduct {
  id: string;
  label: string;
  principalSku: string;
  complementSku: string;
}

export interface KitSerialPair {
  id: string;
  principalSku: string;
  complementSku: string;
  principalSerial: string;
  complementSerial: string;
  createdAt: string;
}

export interface CreateKitSerialPairRequest {
  principalSerial: string;
  complementSerial: string;
}

export interface CreateKitSerialPairResponse {
  principalSku: string;
  complementSku: string;
  principalSerial: string;
  complementSerial: string;
}

export interface GetKitSerialPairsParams {
  principalSerial?: string;
  complementSerial?: string;
  page?: number;
  pageSize?: number;
}

export interface PaginatedKitSerialPairs {
  data: KitSerialPair[];
  total: number;
  page: number;
  pageSize: number;
}

export interface DeleteKitSerialPairResponse {
  success: boolean;
  message: string;
}

export const KIT_PRODUCTS: KitProduct[] = [
  {
    id: 'caja-control-autoinstalacion',
    label: 'Caja autoinstalación + Control',
    principalSku: '35223',
    complementSku: '35220',
  },
];
